import { ElMessage } from 'element-plus'
import { h } from 'vue'
import TEST_ID from '@/testIds.json'

const MESSAGE_TEST_ID_BY_TYPE = {
  success: TEST_ID.APP_ALERT.MESSAGE_SUCCESS,
  error: TEST_ID.APP_ALERT.MESSAGE_ERROR,
  warning: TEST_ID.APP_ALERT.MESSAGE_WARNING,
  info: TEST_ID.APP_ALERT.MESSAGE_INFO,
}

function showMessage(type, mensaje) {
  const messageTestId = MESSAGE_TEST_ID_BY_TYPE[type] || TEST_ID.APP_ALERT.MESSAGE_INFO

  ElMessage({
    type,
    message: h('span', { 'data-testid': messageTestId }, String(mensaje ?? '')),
    duration: 5000,
    showClose: true,
    grouping: false,
    appendTo: document.body
  })
}

export function showError(mensaje) {
  showMessage('error', mensaje)
}

export function showSuccess(mensaje) {
  showMessage('success', mensaje)
}

export function showWarning(mensaje) {
  showMessage('warning', mensaje)
}